<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card >
      <v-card-title>
        <h1 class="headline">
          <v-icon color="black" class="mr-2" size="26">fas fa-share-alt</v-icon>
          Compartir Link
        </h1>
        <v-spacer></v-spacer>
        <v-icon @click="dialog = false">far fa-times-circle</v-icon>
      </v-card-title>
      <v-card-text class="pt-1 mb-0 pb-0">
        <v-sheet height="80">
          <v-text-field
              :hint="hint"
              ref="linkInput"
              @focus="$event.target.select()"
              label="Link"
              :value="url"
              readonly outlined
          />
        </v-sheet>
      </v-card-text>
      <v-card-actions class="">
        <v-spacer></v-spacer>

        <ShareNetwork
            network="twitter"
            :url="url"
            :title="title"
            :description="description"
            :hashtags="hashtags.join(',')"
        >
          <v-btn :fab="$vuetify.breakpoint.smAndDown" class="mx-1" color="#00acee" rounded small depressed outlined >
            <v-icon size="18" :class="$vuetify.breakpoint.mdAndUp ? 'mr-2' : ''">fab fa-twitter</v-icon>
           <span v-if="$vuetify.breakpoint.mdAndUp">twitter</span>
          </v-btn>
        </ShareNetwork>
        <ShareNetwork
            network="facebook"
            :url="url"
            :title="title"
            :description="description"
            :hashtags="hashtags.join(',')"
        >
          <v-btn :fab="$vuetify.breakpoint.smAndDown" class="mx-1" color="#3d5a9b" rounded small depressed outlined >
            <v-icon size="18" :class="$vuetify.breakpoint.mdAndUp ? 'mr-2' : ''">fab fa-facebook-square</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">facebook</span>
          </v-btn>
        </ShareNetwork>

        <ShareNetwork
            network="whatsapp"
            :url="url"
            :title="title"
            :description="description"
            :hashtags="hashtags.join(',')"
        >
          <v-btn :fab="$vuetify.breakpoint.smAndDown" class="mx-1" color="#25d366" rounded small depressed outlined >
            <v-icon size="18" :class="$vuetify.breakpoint.mdAndUp ? 'mr-2' : ''">fab fa-whatsapp</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">whatsapp</span>
          </v-btn>
        </ShareNetwork>

        <v-btn :fab="$vuetify.breakpoint.smAndDown" class="mx-1" color="default" rounded small depressed outlined @click="copyLink">
          <v-icon size="18" :class="$vuetify.breakpoint.mdAndUp ? 'mr-2' : ''">fa-link</v-icon>
          <span v-if="$vuetify.breakpoint.mdAndUp">copiar</span>
        </v-btn>
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LinkShare",
  props:{
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Mi Sitio'
    },
    description: {
      type: String,
      default: 'Visita mi perfil en KimApp, podrás conocer sobre nuestros servicios, agendar citas y... ¡mucho más!'
    },
    hashtags: {
      type: Array,
      default: () => [
          'KimApp',
          'AgendaEnLinea',
          'FichaClinica'
      ]
    }
  },
  data(){
    return {
      hint: '',
      dialog: false
    }
  },
  methods:{
    show(){
      const vm = this
      vm.dialog = true
    },
    hide(){
      const vm = this
      vm.dialog = false
    },
    copyLink(){
      var vm = this

      vm.$refs.linkInput.focus()
      document.execCommand("copy");
      vm.hint = '¡URL copiada!'
    },
  }
}
</script>

<style scoped>
  a{
    text-decoration: none;
  }
</style>
